import React, { Fragment } from 'react'
import { FormInput, FormSubmit, FormWrapper } from '@myxplor/forms'
import withRemoteRequest from '../remote-request'
import { withRouter } from 'react-router-dom'
import { Card } from '@myxplor/ui'

const apiEndPoint = () => process.env.REACT_APP_API_HOST + '/api/registration_holders/new/'

const defaultOnSubmit = ({ remote_request }) => payload =>
  remote_request.submit(apiEndPoint(), {
    method: 'POST',
    jsonAPI: true,
    body: payload,
  })

export const RegisterNew = ({
  formOptions = {},
  name = 'onboarding_service',
  remote_request,
  onSubmit = defaultOnSubmit,
}) => {
  const { loading, success, data } = remote_request.state

  if (success) {
    const { id, name, type, type_id } = data
    return (
      <div>
        <Card>
          <h2>Registration Holder Onboarding Complete</h2>
          <p>Reg Holder ID: {id}</p>
          <p>Reg Holder Name: {name}</p>
          <p>Reg Holder Type: {type}</p>
          <p>Reg Holder Type ID: {type_id}</p>
          <FormWrapper
            onSubmit={() => {
              window.location.href = '/registration_holders/new/'
            }}
            render={() => (
              <FormSubmit>Done</FormSubmit>
            )}
          />
        </Card>
      </div>
    )
  }

  const errors = remote_request.state.errors

  return (
    <Fragment>
      <Card>
        <h2>Connect Service to Kickback</h2>
        <FormWrapper
          {...formOptions}
          onSubmit={onSubmit({ remote_request, name })}
          render={formProps => (
            <fieldset>
              <FormInput
                label="Input Service ID"
                name="service_id"
                value={formProps.values.service_id}
                required
                onChange={formProps.onChange}
                errors={errors ? errors[0] : null}
                loading={loading}
                autoFocus
              />

              <FormSubmit
                loading={loading}
                disabled={!formProps.valid}
                loadingTitle="Onboarding..."
              >
                Onboard Service
              </FormSubmit>
            </fieldset>
          )}
        />
      </Card>
    </Fragment>
  )
}

export default withRouter(withRemoteRequest(RegisterNew))


// WEBPACK FOOTER //
// ./src/register-new/container.js